<div [ngClass]="{'sb-app-bar': !(isMobile && isTouchScreenDevice), 'sb-app-bar-mobile': isMobile && isTouchScreenDevice}">
    <div class="sb-app-bar-left">
        <ng-content select="[headerLeft]"></ng-content>

        
         <ng-content select="[headerTitle]"></ng-content>
        
    </div>

    <div class="sb-app-bar-right">
        <ng-content select="[headerRight]"></ng-content>
    </div>
</div>
<div #appBarBelowContent [hidden]="!appBarBelowContent.textContent" class="sb-app-bar-below">
    <ng-content select="[headerBelow]"></ng-content>
</div>
